import React from 'react';

const ChatMessage = ({ message }) => {
  const formatTime = (timestamp) => {
    return new Date(timestamp).toLocaleTimeString('es-ES', {
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className={`chat-message ${message.role}`}>
      <div className="message-content">
        <p>{message.content}</p>
        {message.sources && message.sources.length > 0 && (
          <div className="message-sources">
            <small>Fuentes: {message.sources.map(s => s.title).join(', ')}</small>
          </div>
        )}
      </div>
      <div className="message-time">
        {formatTime(message.timestamp)}
      </div>
    </div>
  );
};

export default ChatMessage;
